<script setup lang="ts">
  const { heroData, benefitsSectionData, referenceSectionData, servicesSectionContent } = await useHomePage();

  const { contactData, saveContact } = await useContact();
  const { journeyData } = await useJourneyContent();

  false && /*#__PURE__*/ defineI18nRoute({
    paths: {
      en: '/',
      hu: '/'
    }
  });

  useHead({
    title: ''
  });

  const onSubmit = async (data: any) => {
    await saveContact(data);
  };

  const viewport = useViewport();
  const localePath = useLocalePath();

  const onContactClick = () => {
    navigateTo(localePath('ai-mode'));
  };
</script>

<template>
  <main>
    <HeroSection
      v-if="heroData"
      :hero-data="heroData" />
    <BenefitsSection
      v-if="benefitsSectionData"
      :benefits="benefitsSectionData.benefits"
      :heading="benefitsSectionData.heading"
      :is-mobile="viewport.isLessThan('lg')" />
    <ServicesSection
      v-if="servicesSectionContent"
      :is-mobile="viewport.isLessThan('lg')"
      :locale-path="localePath"
      :services-section-content="servicesSectionContent"
      @contact-click="onContactClick" />
    <ReferencesSection
      v-if="referenceSectionData && referenceSectionData.showPartnerSection"
      :reference-section-data="referenceSectionData" />
    <JourneySection
      v-if="journeyData"
      :journey-section-data="journeyData" />
    <ContactSection
      v-if="contactData"
      :contact-data="contactData"
      :locale-path="localePath"
      @on-submit="onSubmit" />
  </main>
</template>
